<template>
  <div>
    <div class="payment-error">
      <div class="overlay">
        &nbsp;
      </div>
      <div class="outer">
        <div class="inner">
          <component
            :is="errorComponent"
            :details="error"
            :txn="txn"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RateLimitExceededError } from '../errors'

import RateLimitExceededException from './exceptions/rate-limit-exceeded.vue'
import SystemError from './exceptions/system-error.vue'

export default {
  name: 'payment-error',
  components: {
    'rate-limit-exceeded-error': RateLimitExceededException,
    SystemError
  },
  props: {
    error: {
      type: Error,
      required: true
    },
    txn: {
      type: Object,
      required: true
    }
  },
  computed: {
    errorComponent: function() {
      if (this.error instanceof RateLimitExceededError) {
        return 'rate-limit-exceeded-error'
      }
      else {
        return 'system-error'
      }
    }
  }
}
</script>

<style lang='scss' scoped>

  .payment-error .outer {
    position: relative;
    z-index: 15;
    margin: 0 auto;
    max-width:80%;
  }
  .payment-error .inner {
    position: absolute;
    background-color: #fff;
    top: 0;
    padding: 2em;
    z-index: 20;
    text-align: center;
    width: 80%;
    border-radius: 3px;
    margin: 2em auto;
    left: 0;
    right: 0;
    box-shadow: 0px 1px 10px 0px #00000040;
  }

  .payment-error .overlay {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .4;
    z-index: 10;
    background-color: #EEE;
  }

</style>
